export default "__VITE_ASSET__773bd098__"